import React from "react";

/**
 * Data-driven L99D lego.
 *
 * Emits the EXACT same markup/class-names as the hand-authored L99D lego
 * (`lego l099D > quadLegoContainer > [lego l099B ...]`), so it reuses the
 * identical compiled CSS already in App.css — nothing new to style.
 *
 * The only thing that changes between this and the conventional approach is
 * AUTHORING: a page section becomes a short array of card objects instead of
 * ~110 lines of copy-pasted JSX. See `managingDiabetesCards.js` for an example
 * manifest, and the lego-page-building playbook for the side-by-side rationale.
 *
 * Card shape: { title, pdf, thumb, description? }
 */
// Exported so LegoL99EData (3-up grid) renders the identical card markup.
export function L99BCard({ title, pdf, thumb, description }) {
  return (
    <div className="lego l099B">
      <div className="legoContainer">
        <div className="imgContainer">
          <a target="_blank" rel="noreferrer" href={pdf}>
            <img className="" src={thumb} alt={title} />
          </a>
        </div>
        <div className="contentContainer">
          <p className="descriptionHeader">{title}</p>
          {description ? <p>{description}</p> : null}
          <p>
            Click image or{" "}
            <a target="_blank" rel="noreferrer" className="blueLinkfont" href={pdf}>
              this link
            </a>{" "}
            to view.
          </p>
        </div>
      </div>
    </div>
  );
}

function LegoL99DData({ cards = [], legoMargin = "" }) {
  return (
    <div className={`lego l099D ${legoMargin}`.trim()}>
      <div className="quadLegoContainer">
        {cards.map((card, i) => (
          <L99BCard key={card.pdf || i} {...card} />
        ))}
      </div>
    </div>
  );
}

export default LegoL99DData;
